import mainBg from "../assests/main-bg.svg";
import logo from "../assests/logo.svg";
import radial from "../assests/radial.svg";
import integrated from "../assests/integrated.svg";
import invesment from "../assests/invesment.svg";
import multi from "../assests/multi.svg";
import secure from "../assests/secure.svg";
import vision from "../assests/vision.svg";
import btcBg from "../assests/btc-bg.svg"
import signBg from "../assests/sign-bg.svg"

export default {
  mainBg,
  logo,
  radial,
  integrated,
  invesment,
  multi,
  secure,
  vision,
  btcBg,
  signBg,
};
